"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
exports.createReducer = (initialState) => (reducerMap) => (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action) : state;
};
exports.createErrorMessageReducer = (prefix) => {
    return (state = null, action) => {
        const type = foundations_1._.get(action, 'type', '').toLowerCase();
        if (!type.startsWith(`${prefix.toLowerCase()}/`)) {
            return state;
        }
        if (type.endsWith('/failure')) {
            return foundations_1._.get(action, 'errorMessage', null);
        }
        if (type.endsWith('/request')) {
            return null;
        }
        return state;
    };
};
exports.createIsProcessingReducer = (prefix) => {
    return (state = false, action) => {
        const type = foundations_1._.get(action, 'type', '').toLowerCase();
        if (!type.startsWith(`${prefix.toLowerCase()}/`)) {
            return state;
        }
        if (type.endsWith('/request')) {
            return true;
        }
        if (type.endsWith('/success')) {
            return false;
        }
        if (type.endsWith('/failure')) {
            return false;
        }
        return state;
    };
};
//# sourceMappingURL=utils.js.map